export default {
  //get all CHAPTERs
  GET_SUPERADMIN_SUBJECTS_REQUEST: "GET_SUPERADMIN_SUBJECTS_REQUEST",
  GET_SUPERADMIN_SUBJECTS_SUCCESS: "GET_SUPERADMIN_SUBJECTS_SUCCESS",
  GET_SUPERADMIN_SUBJECTS_FAIL: "GET_SUPERADMIN_SUBJECTS_FAIL",

  //edit CHAPTERs
  EDIT_SUPERADMIN_SUBJECT_REQUEST: "EDIT_SUPERADMIN_SUBJECT_REQUEST",
  EDIT_SUPERADMIN_SUBJECT_SUCCESS: "EDIT_SUPERADMIN_SUBJECT_SUCCESS",
  EDIT_SUPERADMIN_SUBJECT_FAIL: "EDIT_SUPERADMIN_SUBJECT_FAIL",

  RESTRICT_SUPERADMIN_SUBJECT_REQUEST: "RESTRICT_SUPERADMIN_SUBJECT_REQUEST",
  RESTRICT_SUPERADMIN_SUBJECT_SUCCESS: "RESTRICT_SUPERADMIN_SUBJECT_SUCCESS",
  RESTRICT_SUPERADMIN_SUBJECT_FAIL: "RESTRICT_SUPERADMIN_SUBJECT_FAIL",

  ASQUARA_SUPERADMIN_SUBJECT_REQUEST: "ASQUARA_SUPERADMIN_SUBJECT_REQUEST",
  ASQUARA_SUPERADMIN_SUBJECT_SUCCESS: "ASQUARA_SUPERADMIN_SUBJECT_SUCCESS",
  ASQUARA_SUPERADMIN_SUBJECT_FAIL: "ASQUARA_SUPERADMIN_SUBJECT_FAIL",
  ACTIVE_SUPERADMIN_SUBJECT_REQUEST: "ACTIVE_SUPERADMIN_SUBJECT_REQUEST",
  ACTIVE_SUPERADMIN_SUBJECT_SUCCESS: "ACTIVE_SUPERADMIN_SUBJECT_SUCCESS",
  ACTIVE_SUPERADMIN_SUBJECT_FAIL: "ACTIVE_SUPERADMIN_SUBJECT_FAIL",

  //create CHAPTER
  CREATE_SUPERADMIN_SUBJECT_REQUEST: "CREATE_SUPERADMIN_SUBJECT_REQUEST",
  CREATE_SUPERADMIN_SUBJECT_SUCCESS: "CREATE_SUPERADMIN_SUBJECT_SUCCESS",
  CREATE_SUPERADMIN_SUBJECT_FAIL: "CREATE_SUPERADMIN_SUBJECT_FAIL",

  DELETE_SUPERADMIN_SUBJECT_REQUEST: "DELETE_SUPERADMIN_SUBJECT_REQUEST",
  DELETE_SUPERADMIN_SUBJECT_SUCCESS: "DELETE_SUPERADMIN_SUBJECT_SUCCESS",
  DELETE_SUPERADMIN_SUBJECT_FAIL: "DELETE_SUPERADMIN_SUBJECT_FAIL",

  GET_SUPERADMIN_SUBJECT_REQUEST: "GET_SUPERADMIN_SUBJECT_REQUEST",
  GET_SUPERADMIN_SUBJECT_SUCCESS: "GET_SUPERADMIN_SUBJECT_SUCCESS",
  GET_SUPERADMIN_SUBJECT_FAIL: "GET_SUPERADMIN_SUBJECT_FAIL",

  //loading
  ADD_SUPERADMIN_SUBJECTS_LOADING: "ADD_SUPERADMIN_SUBJECTS_LOADING",
};
